// extracted by mini-css-extract-plugin
export default {"loading":"WidgetLoading_loading__3LtnX","pulse":"WidgetLoading_pulse__NFORC"};